var exports = {
  "D": "Heading__EW3K2O",
  "a": "Box__Rf67d2",
};

module.exports = exports;
